import {Component, Input, SimpleChange, OnChanges, EventEmitter, Output} from '@angular/core';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';

import * as L from 'leaflet';

import { Location } from '../../lib/maps/location';
import { LocatorServiceInterface } from '../locator/locator-service-interface.service';

@Component({
  selector: 'pdmi-locator',
  templateUrl: './locator.component.html',
  styleUrls: ['./locator.component.css']
})
export class LocatorComponent implements OnChanges, AfterViewInit {
  constructor(private locatorServiceInterface: LocatorServiceInterface) { }

  // region Properties
  userLocation: Location;
  searchLocation: Location;
  errorMessage: string;
  error = false;

  // endregion

  // region IO Properties
    @Input() searchAddress = '';
    @Input('displayMap') displayMap: Boolean;

  @Output() locationChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  // endregion

  // region Lifecycle Hooks
  ngOnChanges(change: { [propKey: string]: SimpleChange }): void {
    if (change['searchAddress'] !== change['searchAddress'].previousValue) {
      this.updateLocationBySearch();
    }
  }

    ngAfterViewInit() {
       // alert(this.displayMap);
    this.updateLocationToCurrentPosition();
  }
  // endregion

  // region Methods
  updateLocationToCurrentPosition(): void {
    this.searchAddress = '';
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.userLocation = new Location();
        this.userLocation.latLng = new L.LatLng(
          position.coords.latitude,
          position.coords.longitude
          );
          this.userLocation.description = 'You are here!';
        this.searchLocation = this.userLocation;
        this.locationChanged.emit(true);
      });
    }
  }

    updateLocationBySearch(): void {
      alert("displayMap = " + this.displayMap);
    setTimeout(() => {
      if (this.searchAddress.length > 4) { // minimum use case would be entering a zip code
        this.locatorServiceInterface
          .getLocationByAddress(this.searchAddress)
          .subscribe(
            response => {
                try {
                    var coords = JSON.parse(response);
                    this.searchLocation = new Location();
                    this.searchLocation.latLng = new L.LatLng(
                        coords.latitude,
                        coords.longitude
                    );
                    this.locationChanged.emit(true);
                    this.error = false;
                }
                catch (e) {
                    // do nothing - this is to avoid errors when response is not a valid json object
                }
            },
            err => {
              if (err !== 'undefined' && err.error && err.error.errorMessages) {
                this.errorMessage = err.error.errorMessages;
                this.error = true;
              }
            }
          );
      }
    }, 400);
  }

  // endregion
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/widgets/locator/locator.component.ts